import optimizedImages from '../data/optimizedImages.json';

const isExternalImageSrc = (imageValue) =>
  imageValue.startsWith('http://') ||
  imageValue.startsWith('https://') ||
  imageValue.startsWith('data:');

const normalizeImageKey = (imageValue) =>
  imageValue
    .replace(/^\/images\/optimized\//, '')
    .replace(/^\/images\//, '')
    .split('?')[0]
    .split('#')[0];

export const resolveOriginalImageSrc = (imageValue) => {
  if (!imageValue) {
    return '';
  }

  if (isExternalImageSrc(imageValue) || imageValue.startsWith('/')) {
    return imageValue;
  }

  return `/images/${imageValue}`;
};

export const resolveImageSrc = (imageValue, options = {}) => {
  const { optimized = true } = options;
  const originalImageSrc = resolveOriginalImageSrc(imageValue);

  if (!optimized || !originalImageSrc || isExternalImageSrc(originalImageSrc)) {
    return originalImageSrc;
  }

  const optimizedImageSrc = optimizedImages[normalizeImageKey(originalImageSrc)];

  return optimizedImageSrc || originalImageSrc;
};
